import { generateRandomString } from '../utils/stringHelper';
import { globalErrorHandler } from '../utils/errorHandler';
import { HttpClient } from '../utils/httpClient';

const PATH = {
    product: '/product',
};


const getProductList = (filter, page, callback, error, loader, limit = 50) => {
    const { start, stop } = loader(generateRandomString(5));
    start();

    const offset = parseInt(page * limit) || 0;
    const params = { offset, limit, ...filter };

    return HttpClient.get(`${PATH.product}`, { params }).then(callback).catch(error).finally(stop);
};
const editWishlistProducts = (params, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.post(`${PATH.product}/wishlist`, { params }).then(callback).catch(error).finally(stop);
};
const getWishlistProducts = (callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.get(`${PATH.product}/wishlist`).then(callback).catch(error).finally(stop);
};
const getStockAvailability = (skuId, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    const params = { skuId };
    return HttpClient.get(`${PATH.product}/checkStock`, { params }).then(callback).catch(error).finally(stop);
};
const getProductDetails = (params, callback, error, loader) => {
    const { start, stop } = loader(generateRandomString(5));
    start();
    return HttpClient.get(`${PATH.product}/productDetails`, { params }).then(callback).catch(error).finally(stop);
};

export const ProductService = {
    getProductList,
    editWishlistProducts,
    getWishlistProducts,
    getProductDetails,
    getStockAvailability
};